import React from 'react';
import styled from 'styled-components';
import { media } from '../../lib/styles';
import { spaces, avatars } from '../../lib/styles';
import Pill from '@99designs/frontend-components/components/Pill/Pill';

export interface Props {
    avatar: React.ReactNode;
    role: string;
    message: React.ReactNode;
}

const StyledAvatarWithMessage = styled.div`
    display: grid;
    text-align: left;
    grid-template-columns: min-content;
    grid-template-areas:
        'avatar-container role-container'
        'avatar-container message-container';

    @media ${media('small')} {
        grid-template-areas:
            'avatar-container role-container'
            'message-container message-container';
    }
`;
const AvatarWrapper = styled.div`
    grid-area: avatar-container;
    margin-right: ${spaces.space6}px;

    @media ${media('small')} {
        :first-child {
            width: ${avatars.sizes.small.avatarSize}px;
            height: ${avatars.sizes.small.avatarSize}px;
        }
    }
`;
const Role = styled.div`
    grid-area: role-container;
    display: flex;
    align-items: center;
    padding-top: ${spaces.space5}px;

    :first-child {
        align-self: center;
    }

    @media ${media('small', 'medium')} {
        padding-top: 0;
    }
`;
const Message = styled.div`
    grid-area: message-container;
    padding-top: ${spaces.space5}px;
`;

export default function AvatarWithMessage({ avatar, role, message }: Props) {
    return (
        <StyledAvatarWithMessage data-testid="avatar-with-message">
            <AvatarWrapper>{avatar}</AvatarWrapper>

            <Role>
                <Pill variations={['platinum']}>{role}</Pill>
            </Role>

            <Message>{message}</Message>
        </StyledAvatarWithMessage>
    );
}
